import React, { ReactElement, ReactNode } from "react";
import { Group, Text, Tooltip } from "@mantine/core";
import styles from "../../pages/transactionDetails/TransactionDetailsPage.module.scss";
import { IconHelpSquareRounded } from "@tabler/icons-react";

export default function DetailsRowComponent({
                                              isInputOutput = false,
                                              label,
                                              info,
                                              value,
                                            }: {
  isInputOutput?: boolean;
  label: string;
  info: string | null | undefined;
  value: ReactNode;
}): ReactElement | null {
  return (
    <Group
      className={`${styles.detailRow} ${isInputOutput ? styles.inputOutputValue : ""}`}
    >
      <div className={styles.labelContainer}>
        <div className={styles.textWithHelp}>
          {info && (
            <Tooltip
              label={info}
              position="top"
              events={{
                hover: true,
                focus: false,
                touch: true,
              }}
            >
              <IconHelpSquareRounded
                size={20}
                style={{ flexShrink: 0 }}
              />
            </Tooltip>
          )}

          <Text
            ta={{ sm: "center", md: "left" }}
            fw={700}
            style={{ textWrap: "nowrap" }}
          >
            {label}:
          </Text>
        </div>
      </div>
      {/*Actual value */}
      <div className={styles.valueContainer}>
        <div
          className={`${styles.gradientBackground} ${isInputOutput ? styles.inputOutputValue : ""}`}
        >
          {value}
        </div>
      </div>
    </Group>
  );
}